// Copyright (c) 2017 Deere & Company

import DebitLaborPanel from './debit-labor-panel';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    adjustmentTypes: state.tcsm.partialDebit.adjustmentTypes.filter(adjustmentType => adjustmentType.key !== '03' && adjustmentType.key !== '02'),
    isEditable: true,
    labors: state.tcsm.partialDebit.debit.getLabors()
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {updateAdjustmentType, updateAdjustmentValue} = dispatchProps;

    return {
        ...stateProps,
        actions: {
            updateAdjustmentType,
            updateAdjustmentValue
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DebitLaborPanel);



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-labor-panel/index.js